import { LitElement, html, css } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';

import {
  authenticatedAPICall,
  isSuccessfulAPIResponse,
} from '../../client/api-client';
import { showNotification } from '../../LanghoutBetonPortal';

import { repeat } from 'lit/directives/repeat.js';
import { Account } from '../../types/types';
import '../../elements/list-nagivation/list-navigation';
import '../langhout-beton-view-account/langhout-beton-view-account';
import { refreshIcon, sortIcon } from '../../elements/icons/icons';
import {
  addHistory,
  getQueryParamURL,
  getSearchParam,
} from '../../util/list_util';
import { sharedStyles } from '../../elements/shared-styles';
@customElement('langhout-beton-list-accounts')
export class LanghoutBetonListAccounts extends LitElement {
  static styles = [
    sharedStyles,
    css`
      .row {
        display: flex;
        flex-direction: row;
      }

      .row-flex {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex-flow: row wrap;
      }

      .filter-row {
        min-height: 130px;
      }

      .filter-column {
        margin-bottom: 20px;
      }

      .fat {
        font-weight: 900;
        color: var(--menu-color);
      }

      .label {
        font-weight: bold;
      }

      @media (max-width: 701px) {
        .label {
          text-align: left;
        }
      }

      .product-column {
        text-align: left;
        width: 100%;
        min-width: 120px;
        min-height: calc(54px - 24px);
      }

      .account-id-click {
        font-weight: bold;
        text-decoration: underline;
        text-decoration-color: var(--primary-color);
      }

      .account-id-click:hover {
        cursor: pointer;
      }

      .border-bot {
        border-bottom: 2px solid var(--menu-color);
      }

      .column-large {
        text-align: left;
        min-width: calc(350px - 20px);
        max-width: calc(350px - 20px);
      }

      .table-wrapper {
        overflow-x: auto;
      }

      .table-header {
        color: var(--text-color-light);
      }

      .header-column {
        background-color: var(--menu-color);
        padding-left: 12px;
      }

      .column-border-right {
        border-right: 2px solid var(--menu-color);
      }

      .navigation-wrapper {
        margin-top: 20px;
      }

      langhout-beton-view-account {
        position: absolute;
        top: 84px;
        right: -200vw;
      }

      :host([backAnimation]) langhout-beton-view-account {
        transition-duration: 500ms;
      }

      :host([viewAccount]) langhout-beton-view-account {
        transition-duration: 500ms;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        width: calc(100vw - 60px);
        height: calc(100vh -84px);
        top: 84px;
      }

      .sort-icon-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .sort-icon {
        transform: rotate(90deg);
      }

      .sort-icon:hover {
        cursor: pointer;
      }

      .sort-active {
        color: var(--text-color-main);
      }

      .account-id-column {
        padding-left: 10px;
        padding-right: 10px;
      }

      #resetButton,
      #searchExactButton {
        margin-top: 20px;
        margin-left: 30px;
      }
    `,
  ];

  private requestCounter = 0;

  private listTimer = 0;

  @property({ type: Array })
  private accounts: Account[] = [];

  @property({ type: Number })
  private accountCount = 0;

  @query('#name')
  public name?: HTMLInputElement;

  @query('#code')
  public code?: HTMLInputElement;

  @query('#searchCode')
  public searchCode?: HTMLInputElement;

  @property({ type: Array, attribute: true })
  public selected: Array<string> = [];

  private offset = 0;

  private limit = 50;

  @property({ type: Boolean, reflect: true })
  public viewAccount = false;

  @property({ type: Boolean, reflect: true })
  public backAnimation = false;

  @property({ type: Object })
  private currentViewAccount: Account = <Account>{};

  private orderByColumn = '';

  private orderByDirection = '';

  @property({ type: String })
  private lastPath = 'unknown';

  constructor() {
    super();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
  }

  protected routerLocationChanged = (): void => {
    this.setPropertiesFromURL();
    this.listWithBackoff(false);
  };

  protected firstUpdated(): void {
    window.addEventListener(
      'vaadin-router-location-changed',
      this.routerLocationChanged as EventListener,
    );
    this.setPropertiesFromURL();
    this.listWithBackoff(false);
  }

  protected setPropertiesFromURL = (): void => {
    const url = getQueryParamURL();
    if (this.name) {
      this.name.value = getSearchParam(url, 'name');
    }
    if (this.code) {
      this.code.value = getSearchParam(url, 'code');
    }

    this.orderByColumn = getSearchParam(url, 'order_by');
    this.orderByDirection = getSearchParam(url, 'order_direction');
  };

  render() {
    return html`
      <langhout-beton-view-account
        .currentViewAccount=${this.currentViewAccount}
        @close="${() => {
          this.viewAccount = false;
          this.listWithBackoffWithoutReset();
        }}"
        @reload=${() => {
          this.listWithBackoffWithoutReset();
        }}
      ></langhout-beton-view-account>
      ${this.renderFilterRow()}
      <div class="table-wrapper">
        <div class="row table-header">
          <div class="column header-column product-column">
            <div class="row">
              <h3>Naam</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('name')}"
                @click="${() => {
                  this.orderColumns('name');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Code</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('code')}"
                @click="${() => {
                  this.orderColumns('code');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Type</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive(
                  'customer_type_description',
                )}"
                @click="${() => {
                  this.orderColumns('customer_type_description');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>KvK Nr.</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive(
                  'chamber_of_commerce_number',
                )}"
                @click="${() => {
                  this.orderColumns('chamber_of_commerce_number');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>BTW Nr.</h3>
              <div class="fill"></div>
              <div
                class="sort-icon-wrapper ${this.isSortActive('vat_number')}"
                @click="${() => {
                  this.orderColumns('vat_number');
                }}"
              >
                ${sortIcon()}
              </div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Contact</h3>
              <div class="fill"></div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Email</h3>
              <div class="fill"></div>
            </div>
          </div>
          <div class="column header-column product-column">
            <div class="row">
              <h3>Plaats</h3>
              <div class="fill"></div>
            </div>
          </div>
        </div>
        ${this.renderRows()}
      </div>
      <div class="navigation-wrapper">
        <list-navigation
          index="${this.offset}"
          limit="${this.limit}"
          total="${this.accountCount}"
          @change="${(e: CustomEvent) => {
            if (this.offset != e.detail.value) {
              this.offset = parseInt(e.detail.value);
              this.listWithBackoffWithoutReset();
            }
          }}"
        ></list-navigation>
      </div>
    `;
  }

  renderFilterRow = () => {
    return html`
      <div class="row-flex filter-row">
        <div class="column filter-column">
          <div class="label">Naam</div>
          <div class="input-field">
            <input
              type="text"
              id="name"
              name="name"
              @input="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <div class="column filter-column">
          <div class="label">Code</div>
          <div class="input-field">
            <input
              type="text"
              id="code"
              name="code"
              @input="${() => {
                this.listWithBackoff();
              }}"
            />
          </div>
        </div>
        <langhout-button
          text="Reset filters"
          id="resetButton"
          @click="${(): void => {
            window.location.href = '/accounts';
          }}"
        ></langhout-button>

        <div class="fill"></div>
        <div class="row filter-column"></div>
      </div>

      <div class="row-flex filter-row">
        <div class="column filter-column">
          <div class="label">Code</div>
          <div class="input-field">
            <input
              type="number"
              id="searchCode"
              name="searchCode"
              maxlength="6"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            />
          </div>
        </div>
        <langhout-button
          text="Klant data ophalen Exact"
          id="searchExactButton"
          @click="${(): void => {
            this.retrieveAccountExact();
          }}"
        ></langhout-button>
        <div class="fill"></div>
        <div
          @click="${() => {
            showNotification('Refreshing accounts');
            this.listWithBackoff();
          }}"
        >
          ${refreshIcon()}
        </div>
      </div>
    `;
  };

  renderRows = () => {
    return html` ${repeat(
      this.accounts,
      account => account.id,
      (account, index) => {
        let tableColumnClass = 'border-bot';
        if (index == this.accounts.length - 1) {
          tableColumnClass = '';
        }
        return html`
          <div
            class="row table-row"
            @click="${() => {
              this.currentViewAccount = account;
              this.viewAccount = !this.viewAccount;
              this.backAnimation = true;
            }}"
          >
            <div
              class="row account-id-column table-column account-id-click column-border-right product-column ${tableColumnClass}"
            >
              ${account.name}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${account.code}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${this.formatCustomerDescriptionType(
                account.customer_type_description,
              )}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${account.chamber_of_commerce_number}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${account.vat_number}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${account.contact_person.first_name}
              ${account.contact_person.middle_name}
              ${account.contact_person.last_name}
            </div>
            <div
              class="column table-column column-border-right product-column ${tableColumnClass}"
            >
              ${account.email_address}
            </div>

            <div class="column table-column product-column ${tableColumnClass}">
              ${account.address.city}
            </div>
          </div>
        `;
      },
    )}`;
  };

  formatCustomerDescriptionType = (descType: string): string => {
    if (descType === 'Supplier') {
      return 'Leverancier';
    }
    return 'Klant';
  };

  isSortActive = (column: string): string => {
    if (this.orderByColumn === column) {
      return 'sort-active';
    }
    return '';
  };

  orderColumns = (column: string) => {
    if (this.orderByColumn === column && this.orderByDirection === '') {
      this.orderByDirection = 'asc';
    } else if (
      this.orderByColumn === column &&
      this.orderByDirection === 'asc'
    ) {
      this.orderByColumn = '';
      this.orderByDirection = '';
    } else {
      this.orderByColumn = column;
      this.orderByDirection = '';
    }
    this.listWithBackoff();
  };

  listWithBackoffWithoutReset = () => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.listAccounts();
    }, 50);
  };

  listWithBackoff = (recordHistory: boolean = true) => {
    clearInterval(this.listTimer);
    this.listTimer = window.setTimeout(() => {
      this.offset = 0;
      this.listAccounts(recordHistory);
    }, 50);
  };

  createFilterArray = (): string[] => {
    const filterArray: string[] = [];
    const nameFilter = this.name ? this.name.value : '';
    if (nameFilter != '') {
      filterArray.push(`name=${nameFilter}`);
    }

    const codeFilter = this.code ? this.code.value : '';
    if (codeFilter != '') {
      filterArray.push(`code=${codeFilter}`);
    }

    filterArray.push(`order_by=${this.orderByColumn}`);
    filterArray.push(`order_direction=${this.orderByDirection}`);
    return filterArray;
  };

  listAccounts = async (recordHistory: boolean = true) => {
    this.requestCounter++;
    const requestCounter = this.requestCounter;
    const filterArray = this.createFilterArray();

    let path = `/accounts?limit=${this.limit}&offset=${this.offset}`;
    const filter = filterArray.join('&');
    if (filter !== '') {
      if (recordHistory) {
        addHistory(filter);
      }
      path += '&' + filter;
    }

    const result = await authenticatedAPICall(path, 'GET', new Headers());
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    if (requestCounter != this.requestCounter) {
      return;
    }
    const xCount = result.headers.get('x-count');
    if (xCount) {
      this.accountCount = parseInt(xCount);
    }

    this.accounts = result.body;
    // If we have a selected view account overwrite.
    if (this.currentViewAccount.id != '') {
      this.accounts.forEach((account: Account) => {
        if (this.currentViewAccount.id === account.id) {
          this.currentViewAccount = account;
        }
      });
    }
  };

  retrieveAccountExact = async () => {
    const searchCode = this.searchCode ? this.searchCode.value : '';
    if (searchCode.length != 6) {
      showNotification('klant code moet bestaan uit 6 cijfers');
      return;
    }
    showNotification(
      'klant data ophalen uit exact, dit kan een aantal seconde duren...',
    );

    if (this.searchCode) {
      this.searchCode.value = '';
    }
    const path = `/accounts/exact/${searchCode}`;

    const result = await authenticatedAPICall(path, 'PUT', new Headers());
    if (!isSuccessfulAPIResponse(result)) {
      return;
    }
    showNotification('klant data succesvol bijgewerkt');
  };
}

declare global {
  interface HTMLElementTagNameMap {
    'langhout-beton-list-accounts': LanghoutBetonListAccounts;
  }
}
